import { handleErrors } from '../actions/ErrorActions';
import { forceSavedSearchRefresh } from '../actions/SavedSearchesActions';
import * as successActions from '../actions/SuccessActions';
import * as submitQueueSetupRecordApi from '../api/submit-queue-setup-record';
import { ACTION_NAME } from '../constants/QueueSetupConstant';

export const queueProcessRecord = (entityName, actionName, rows, translate) => async (dispatch) => {
  try {
    const response = await submitQueueSetupRecordApi.submitQueueProcessRecord(
      entityName,
      actionName,
      rows
    );

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      return;
    }
  } catch (error) {
    dispatch(handleErrors([{ errorMessage: error.message }]));
    return;
  }
  const bannerMessages =
    actionName.trim().toLowerCase() === ACTION_NAME.RESUBMIT
      ? translate('Records Resubmitted Successfully')
      : actionName.trim().toLowerCase() === ACTION_NAME.DELETE
      ? translate('Records Deleted Successfull')
      : translate('Records Terminated Successfully');
  dispatch(successActions.addSuccess({ message: bannerMessages }));
  dispatch(forceSavedSearchRefresh(entityName, true));
};
